import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Content from './Content'
import Form from './Form'
import VisibilitySensor from '../VisibilitySensor'
import AssignId from '../AssignId'

const styles = theme => ({
    root: {
        padding: '75px 20rem',
        display: 'flex',
        position: 'relative',
        flexDirection: 'column',
        background: 'linear-gradient(180deg, #fff 0%, #FFF 100%)',
        justifyContent: 'center',
        alignItems: 'center',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 1300)]: {
            padding: '100px 10px',
            height: 'auto',
            textAlign: 'center'
        },
        [theme.breakpoints.down(theme.breakpoints.values.xs + 760)]: {
            padding: '50px 10px 140px 10px',
            height: 'auto',
            textAlign: 'center'
        }
    }
})

const useStyles = makeStyles(styles)

export default function FormPage() {
    const classes = useStyles()
    return (
        <div >
            <VisibilitySensor index={7} />
            <div id='formPage' className={classes.root} >
                <AssignId
                    id='contatti'
                    absolute
                    y='-30px'
                    yMobile='-20px'
                />
                <Content
                    primaryText='Contattaci'
                    secondaryText='Partiamo con basi solide. Compila il form per richiedere tutte le informazioni.'
                />
                <Form />
            </div>
        </div>
    )
}
